import { Button } from "@/components/Base/Button";
import { useI18n } from "@/i18n/hooks";
import "./AppDownloadButton.scss";

export interface AppDownloadButtonProps {
  /** 点击回调，通常用于打开 AppDownloadDialog */
  onClick: () => void;
  className?: string;
}

/**
 * App 下载按钮：置于品牌渐变下载条（首页顶部 / 个人中心底部）上的统一按钮。
 * 首页与个人中心两处共用同一实现，保证视觉与交互一致。
 */
export function AppDownloadButton({
  onClick,
  className = "",
}: AppDownloadButtonProps) {
  const { t } = useI18n();

  return (
    <Button
      variant="outline"
      className={`appDownloadButton ${className}`.trim()}
      onClick={onClick}
      shape="rounded"
      size="sm"
    >
      {t("common.download")}
    </Button>
  );
}

export default AppDownloadButton;
